.error-badge {
  height: 24px;
  align-items: center;
}
